/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { TierDetailDTO } from "./TierDetailDTO";
import type { UpgradeProcessInfoDTO } from "./UpgradeProcessInfoDTO";

export type AvailableTiersResponseDTO = {
  currentTierName?: AvailableTiersResponseDTO.currentTierName;
  /**
   * Indicates if the upgradeProcessInfo object is present (not null)
   */
  hasUpgradeProcessInfo?: boolean;
  /**
   * Purpose of onboarding. Can be CUSTOMER_SIGN_UP or NON_CUSTOMER_SIGN_UP
   */
  onboardingPurpose?: AvailableTiersResponseDTO.onboardingPurpose;
  tiers?: Array<TierDetailDTO>;
  upgradeProcessInfo?: UpgradeProcessInfoDTO;
};

export namespace AvailableTiersResponseDTO {
  export enum currentTierName {
    BRONZE = "BRONZE",
    SILVER = "SILVER",
    GOLD = "GOLD",
    PLATINUM = "PLATINUM",
  }

  /**
   * Purpose of onboarding. Can be CUSTOMER_SIGN_UP or NON_CUSTOMER_SIGN_UP
   */
  export enum onboardingPurpose {
    CUSTOMER_SIGN_UP = "CUSTOMER_SIGN_UP",
    NON_CUSTOMER_SIGN_UP = "NON_CUSTOMER_SIGN_UP",
  }
}
